import {useState, useCallback} from 'react';

import {setIsNavigationEnabled, returnFocus} from '../../../_shared/GWTBridge/invoke/genPage';
import {keyCodes} from '../../../constants';
import {useRteQuery, useRteMutation} from './useRteQuery';

import {saveRowSubform} from '../../../_legacy/Form/services/reconFormService';
import {useQueryClient} from 'react-query';
import {useEventListener} from '../../../hooks/useEventListener';
import {isReconTabledFilled} from '../../../_shared/GWTBridge/invoke/recon';

export const useRte = richTextEditor => {
    const [htmlValue, setHtmlValue] = useState(richTextEditor.createEmptyValue());
    const [isOpen, setIsOpen] = useState(false);

    const {isLoading: isLoadingText, isFetching} = useRteQuery(data => {
        data && setHtmlValue(richTextEditor.createValueFromString(data.Content, 'html'));
    }, isOpen);

    const {mutate, isLoading: isLoadingSave} = useRteMutation();
    const queryClient = useQueryClient();

    const handleClose = useCallback(() => {
        setIsOpen(false);
        returnFocus();
        setIsNavigationEnabled(true);
        setHtmlValue(richTextEditor.createEmptyValue());
    }, [richTextEditor]);

    const handleKeyDown = useCallback(
        e => {
            if (isOpen && e.keyCode === keyCodes.ESC) {
                e.stopPropagation();
                handleClose();
            }
        },
        [handleClose, isOpen]
    );

    useEventListener('keydown', handleKeyDown);

    const handleOpen = async () => {
        if (isReconTabledFilled()) {
            await saveRowSubform();
            setIsOpen(true);
            setIsNavigationEnabled(false);
        }
    };

    const handleSave = async () => {
        mutate(htmlValue, {
            onSuccess: handleClose
        });
    };

    const handleAbortGetText = () => {
        queryClient.cancelQueries('rteText');
        handleClose();
    };

    return {
        isOpen,
        isLoading: isLoadingText || isFetching || isLoadingSave,
        htmlValue,
        handleOpen,
        setHtmlValue,
        handleSave,
        handleClose,
        handleAbortGetText
    };
};
